import _ from 'lodash';
import moment from 'moment';

import Rest from './data/rest';


export default class Billing extends Rest {
  static defaultQuery = {
    sort: 'name',
    // Allow companies of any status so we don't miss billables on archived companies
    where: { status: { not: null } },
    load: {}
  }

  static getDefaultLoad(query) {
    const maxDate = _.get(query, 'releaseDate.max') ? moment(query.releaseDate.max) : moment();
    const minDate = _.get(query, 'releaseDate.min') ? moment(query.releaseDate.min) : null;
    const status = query.billingStatus || [];
    const load = {};
    const dates = { '<=': maxDate.endOf('day').toDate() };
    const where = {};

    if (minDate) dates['>='] = minDate.startOf('day').toDate();
    if (status.length === 1) where.invoice = _.includes(status, 'Billed') ? { not: null } : null;

    const defaultLoad = {
      timeReport: {
        timeReports: _.assign({ date: dates, billable: true }, where),
        'timeReports.rate': '',
        'timeReports.agreement': '',
        'timeReports.agreement.rates': '',
        'timeReports.ticket.agreement': ''
      },
      expenseBill: {
        expenseBills: _.assign({ date: dates }, where),
        'expenseBills.receipt': '',
        'expenseBills.agreement': '',
        'expenseBills.ticket.agreement': '',
        'expenseBills.lineItems': '',
        'expenseBills.purchaseOrder.ticket': '',
        'expenseBills.lineItems.purchaseOrderLineItem': ''
      },
      billing: {
        billings: _.assign({ releaseDate: dates }, where),
        'billings.agreement': ''
      }
    };

    _.forEach(query.billingType, type => {
      _.assign(load, defaultLoad[type]);
    });

    return load;
  }

  static mapFilters(filters) {
    const { company, team } = filters;

    return { id: company, team };
  }

  /**
   * getBillables returns a flat array of all of the billable items on each company
   * to allow iterating through to check all items in a range. The billable items are still displayed
   * on their company object, but their toggled state is updated on the billable array.
   *
   * Since the billable array and company object both reference the same billable object, updating
   * the billable object in one location causes the change to be reflected in the other location
   */
  static getBillables(companies) {
    let billables = [];

    _.forEach(companies, (company) => {
      billables = billables.concat(company.timeReports, company.billings, company.expenseBills);
    });

    return billables;
  }

  /**
   * createInvoices takes an array of companies with their billable items and
   * generates invoices
   */
  static createInvoices(companies) {
    const invoices = _.map(companies, (company) =>
    ({
      invoiceDate: moment().toDate(),
      dueDate: moment().add(company.paymentTerm, 'days').toDate(),
      company: company.id,
      paymentMethod: company.paymentMethod,
      deliveryMethod: company.invoiceMethod,
      hideBillDetails: !!company.hideBillDetails,
      timeReports: _.map(_.filter(company.timeReports, { checked: true }), (val) => ({ id: val.id })),
      billings: _.map(_.filter(company.billings, { checked: true }), (val) => ({ id: val.id })),
      expenseBills: _.map(_.filter(company.expenseBills, { checked: true }), (val) => ({ id: val.id }))
    })
    );

    _.remove(invoices, (invoice) =>
      !invoice.timeReports.length && !invoice.billings.length && !invoice.expenseBills.length
    );

    return invoices;
  }
}



// WEBPACK FOOTER //
// ./app/services/billing.js